<ng-container >
  <h1 class="form-title mt-4" translate>finance-data.bank</h1>
  <form class="finance-form" [formGroup]="kontaktForm">
    <div>
      <kendo-formfield class="text-field">
        <kendo-label class="form-label" [text]="appendAsteriskIfRequired('finance-data.bank.name' | translate)" [infotooltip]="'finanzdaten.namedeskreditinstituts'"></kendo-label>
        <kendo-textbox formControlName="nameDesKreditInstituts" [appinfotext]="'finanzdaten.namedeskreditinstituts'"
          preventEmptyFormatter [maxlength]=100>
        </kendo-textbox>
      </kendo-formfield>

      <kendo-formfield class="text-field">
        <kendo-label class="form-label" [text]="appendAsteriskIfRequired('finance-data.bank.accountHolder' | translate)" [infotooltip]="'finanzdaten.kontoinhaber'"></kendo-label>
        <kendo-textbox formControlName="kontoinhaber" [appinfotext]="'finanzdaten.kontoinhaber'"
          preventEmptyFormatter [maxlength]=100>
        </kendo-textbox>
      </kendo-formfield>
    </div>
    <div>
      <kendo-formfield class="text-field">
        <kendo-label class="form-label" [text]="appendAsteriskIfRequired('finance-data.bank.accountNumber' | translate)" [infotooltip]="'finanzdaten.iban'"></kendo-label>
        <kendo-textbox formControlName="iban" [appinfotext]="'finanzdaten.iban'" preventEmptyFormatter [maxlength]=100>
        </kendo-textbox>
      </kendo-formfield>

      <kendo-formfield class="text-field">
        <kendo-label class="form-label" [text]="appendAsteriskIfRequired('finance-data.bank.bic' | translate)" [infotooltip]="'finanzdaten.bic'"></kendo-label>
        <kendo-textbox formControlName="bic" [appinfotext]="'finanzdaten.bic'" preventEmptyFormatter [maxlength]=100></kendo-textbox>
      </kendo-formfield>
    </div>
  </form>
</ng-container>